// extracted by mini-css-extract-plugin
module.exports = {"restaurantCardList":"RestaurantCardList_restaurantCardList__3h8zc","restaurantCard":"RestaurantCardList_restaurantCard__3vzny"};